import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { action, API, controller } from "../../../../api/api";
import { Grid } from "@mui/material";
import SupplierInfo from "../SupplierInfo";
import Accounts from "../Accounts/Accounts";

const ViewSupplier = () => {
  const { supplierId } = useParams();
  const [supplier, setSupplier] = useState({});

  useEffect(() => {
    supplierId &&
      API(controller.Supplier + action.GetById).getById(supplierId, (res) => {
        res && res.status === 200 && setSupplier(res.result);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [supplierId]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={8.5} order={{ xs: 2, md: 1 }}>
        <div>
          <Accounts supplier={supplier} />
        </div>
      </Grid>
      <Grid item xs={12} md={3.5} order={{ xs: 1, md: 2 }}>
        <SupplierInfo {...{ supplier }} />
      </Grid>
    </Grid>
  );
};

export default ViewSupplier;
